export default {
  sm: `
  데이터센터 각 브랜드 마크의 기본 개념은 가치
  있는 지식과 정보를 안전하게 보관한다는 의미를
  담은 ‘정보의 궤(chest of data)’입니다. 색상이
  가미되지 않은 단색조의 사각형은 이성적 사고와
  판단력, 안전한 보관에 대한 의지와 함께 디지털
  데이터 자체를 시각화하고 있습니다.
  `,
  md: `
  데이터센터 각 브랜드 마크의 기본 개념은 가치 있는
  지식과 정보를 안전하게 보관한다는 의미를 담은
  ‘정보의 궤(Chest of data)’입니다. 색상이 가미되지
  않은 단색조의 사각형은 이성적 사고와 판단력, 안전한
  보관에 대한 의지와 함께 디지털 데이터 자체를 시각화
  하고 있습니다.
  `,
  lg: `
  데이터센터 각 브랜드 마크의 기본 개념은 가치 있는 지식과 정보를 안전하게 보관한다는 의미를
  담은 ‘정보의 궤(chest of data)’입니다. 색상이 가미되지 않은 단색조의 사각형은 이성적 사고와 판단력,
  안전한 보관에 대한 의지와 함께 디지털 데이터 자체를 시각화하고 있습니다.
  `,
  xxl: `
  데이터센터 각 브랜드 마크의 기본 개념은 가치 있는 지식과 정보를 안전하게 보관한다는 의미를 담은
  ‘정보의 궤(chest of data)’입니다. 색상이 가미되지 않은 단색조의 사각형은 이성적 사고와 판단력,
  안전한 보관에 대한 의지와 함께 디지털 데이터 자체를 시각화하고 있습니다.
  `
};
